import { preload } from "swr";
import { fetchUserRebate } from "~/api/endpoints";

export const rebateLoader = () => {
    preload("api_rebate", fetchUserRebate);
    return true;
};
